<template>
  <div>
    <v-list
      v-for="panel in items"
      :key="panel.name">
      <h4 class="section-text">{{panel.name}}</h4>
      <v-list-group
        v-for="item in panel.children"
        :key="item.name"
        append-icon="">
        <template v-slot:activator>
          <v-list-item :to="item.path" @click="closeSideMenu(item.path)">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import items from './navData'
export default {
  name: 'navs',
  data: () => ({
    items
  }),
  methods: {
    closeSideMenu (itemPath) {
      if (itemPath === '/selector' && this.isOpen === true) {
        this.$store.commit('sidebarModule/toggleSidebar')
      }
    }
  },
  computed: {
    isOpen () {
      return this.$store.state.sidebarModule.isOpen
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sidebar/navs.vue